export const UPDATE_CAMERA          = 'UPDATE_CAMERA';
export const UPDATE_HOVERED_LAYER   = 'UPDATE_HOVERED_LAYER';
export const FETCH_RESINS           = 'FETCH_RESINS';
export const FETCH_RESINS_FULFILLED = 'FETCH_RESINS_FULFILLED';
export const FETCH_RESINS_REJECTED  = 'FETCH_RESINS_REJECTED';

export const UPDATE_LAYER           = 'UPDATE_LAYER';
export const INIT_STACKUP           = 'INIT_STACKUP';
export const ADD_LAYER              = 'ADD_LAYER';
export const DELETE_LAYERS          = 'DELETE_LAYERS';

export const UPDATE_START_NEW_FORM  = 'UPDATE_START_NEW_FORM';
export const CLEAR_START_NEW_FORM   = 'CLEAR_START_NEW_FORM';

export const SAVE_STACKUP           = 'SAVE_STACKUP';
export const SAVE_STACKUP_FULFILLED = 'SAVE_STACKUP_FULFILLED';
export const SAVE_STACKUP_REJECTED  = 'SAVE_STACKUP_REJECTED';

export const TRIGGER_CALCULATIONS            = 'TRIGGER_CALCULATIONS';
export const UPDATE_CALCULATIONS             = 'UPDATE_CALCULATIONS';
export const UPDATE_CALCULATIONS_FULFILLED   = 'UPDATE_CALCULATIONS_FULFILLED';
export const UPDATE_CALCULATIONS_REJECTED    = 'UPDATE_CALCULATIONS_REJECTED';
export const UPDATE_CALCULATIONS_DISPLAY_MHZ = 'UPDATE_CALCULATIONS_DISPLAY_MHZ';

export const RESTORE_STACKUP        = 'RESTORE_STACKUP';
export const RESTORE_CALCULATIONS   = 'RESTORE_CALCULATIONS';

export const UPDATE_PREFERENCE = Symbol('UPDATE_PREFERNCE');



// WEBPACK FOOTER //
// ./src/actions/action-types.js